<script>
  import EqualHeight from "../components/equalHeight";
  import {
    flavor,
    roast,
    shippingFrequency,
    size,
    paymentFrequency,
    flavorDisplayValue,
    roastDisplayValue,
    shippingFrequencyDisplayValue,
    sizeDisplayValue,
    paymentFrequencyDisplayValue,
    standardizedPaymentFrequency
  } from "./subscriptions/stores.js";
  import PropertyOption from "./subscriptions/propertyOption.svelte";
  import Heading from "./subscriptions/heading.svelte";
  import HiddenField from "./subscriptions/hiddenField.svelte";
  import SummaryItem from "./subscriptions/summaryItem.svelte";

  export let debug;
  export let recurring;

  EqualHeight.normalizeImageHeights(500);

  let chosenVariantId = null;
  let chosenSellingPlanId = null;
  let price = 0;
  let shipmentCount = null;
  let perShipmentPrice = null;
  let comparePerShipmentPrice = null;
  let showBulkSizes = false;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  });

  shippingFrequencyDisplayValue.subscribe(value => {
    checkForChosenVariant();
  });
  paymentFrequencyDisplayValue.subscribe(value => {
    checkForChosenVariant();
  });
  sizeDisplayValue.subscribe(value => {
    checkForChosenVariant();
  });

  function handleBulkSizesClick() {
    showBulkSizes = true;
    EqualHeight.normalizeImageHeights(500);
  }

  function checkForChosenVariant() {
    const selector = `.js-variant-list option[data-option1='${$sizeDisplayValue}'][data-delivery-frequency='${$shippingFrequencyDisplayValue}'][data-payment-frequency='${$paymentFrequencyDisplayValue}']`;
    if (jQuery(selector).length) {
      const chosenVariant = jQuery(selector).eq(0);
      chosenVariantId = chosenVariant.attr("value");
      chosenSellingPlanId = chosenVariant.data("selling-plan-id");
      price = chosenVariant.data("price");
      shipmentCount = $standardizedPaymentFrequency[0] / $shippingFrequency[0];
      perShipmentPrice = formatter.format(
        parseFloat(price.replace(/[^\d.]/g, "")) / shipmentCount
      );
      if (chosenVariant.data("compare-price") != perShipmentPrice) {
        comparePerShipmentPrice = `${chosenVariant.data("compare-price")}`;
      }
    } else {
      chosenVariantId = null;
      chosenSellingPlanId = null;
    }
  }
</script>

<div>
  <section
    id="flavor"
    class="subscriptions-section subscriptions-section--1">
    <div class="subscriptions-section-vwrap">
      <Heading
        text="1. Which Flavor Profile?"
        img="https://coavacoffee.com/uploads/subscriptions/subscription_profile_folded.jpg" />

      <div class="grid grid--4_aggressive grid--align_top">
        <PropertyOption
          group="flavor"
          value="Classic Coffees"
          description="Coffees balanced towards richness and&nbsp;chocolate"
          img="https://coavacoffee.com/uploads/subscriptions/subscription_profile_01.jpg" />
        <PropertyOption
          group="flavor"
          value="Seasonal Coffees"
          description="Keep it fresh with a rotating selection of all our
          seasonal&nbsp;offerings"
          img="https://coavacoffee.com/uploads/subscriptions/subscription_profile_02.jpg" />
        <PropertyOption
          group="flavor"
          value="Unique Coffees"
          description="Coffees balanced towards sweetness and&nbsp;fruit"
          img="https://coavacoffee.com/uploads/subscriptions/subscription_profile_03.jpg" />
        <PropertyOption
          group="flavor"
          value="Decaf"
          description="Just want decaf? This one’s for&nbsp;you"
          img="https://coavacoffee.com/uploads/subscriptions/subscription_profile_04.jpg" />
      </div>
    </div>
  </section>

  <section id="roast" class="subscriptions-section">
    <div class="subscriptions-section-vwrap">
      <Heading
        text="2. Which Roast?"
        img="https://coavacoffee.com/uploads/subscriptions/subscription_type_01.jpg" />

      <div class="grid grid--2 grid--align_top">
        <PropertyOption
          group="roast"
          value="Drip"
          description="Roasted for all brew methods except espresso"
          img="https://coavacoffee.com/uploads/subscriptions/subscription_type_01.jpg" />
        <PropertyOption
          group="roast"
          value="Espresso"
          description="For use with an espresso machine. This is a more
          developed roast profile."
          img="https://coavacoffee.com/uploads/subscriptions/subscription_type_02.jpg" />
      </div>
    </div>
  </section>

  <section id="option2" class="subscriptions-section">
    <div class="subscriptions-section-vwrap">
      <Heading
        text="3. How Often?"
        img="https://coavacoffee.com/uploads/subscriptions/subscription_howoften_01.jpg" />

      <div class="grid grid--2 grid--align_top">
        <PropertyOption
          group="shippingFrequency"
          value={[2, 'Weeks']}
          displayValue="Bi-Weekly"
          description="Shipped every other week"
          img="https://coavacoffee.com/uploads/subscriptions/subscription_howoften_01.jpg" />
        <PropertyOption
          group="shippingFrequency"
          value={[1, 'Months']}
          displayValue="Monthly"
          description="Shipped once a month."
          img="https://coavacoffee.com/uploads/subscriptions/subscription_howoften_02.jpg" />
      </div>
    </div>
  </section>

  <section id="option1" class="subscriptions-section">
    <div class="subscriptions-section-vwrap">
      <Heading
        text="4. How Much Coffee?"
        img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_01.png" />

      <div class="grid grid--3 grid--align_top">
        <PropertyOption
          group="size"
          value="1 x 300 gram bag"
          description="$22 / bag"
          img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_01.png" />
        <PropertyOption
          group="size"
          value="2 x 300 gram bags"
          description="$21 / bag"
          img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_02.png" />
        <PropertyOption
          group="size"
          value="3 x 300 gram bags"
          description="$21 / bag"
          img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_03.png" />
        <PropertyOption
          group="size"
          value="1 x 1 kilo bulk bag"
          description="$57 / bag"
          img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_bulk_01.png" />
        <PropertyOption
          group="size"
          value="2 x 1 kilo bulk bags"
          description="$57 / bag"
          img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_bulk_02.png" />
        <PropertyOption
          group="size"
          value="3 x 1 kilo bulk bags"
          description="$57 / bag"
          img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_bulk_03.png" />
        {#if showBulkSizes}
          <PropertyOption
            group="size"
            value="1 x 2 kilo bulk bag"
            description="$110 / bag"
            img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_bulk_01.png" />
          <PropertyOption
            group="size"
            value="2 x 2 kilo bulk bags"
            description="$110 / bag"
            img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_bulk_02.png" />
          <PropertyOption
            group="size"
            value="3 x 2 kilo bulk bags"
            description="$110 / bag"
            img="https://coavacoffee.com/uploads/subscriptions/2020-subscription_howmuch_bulk_03.png" />
        {:else}
          <a
            on:click|preventDefault={() => handleBulkSizesClick()}
            href="javascript:void(0);"
            title="Show bulk sizes"
            class="subscriptions-show_more">
            <h3>Need to supply an office?</h3>
            <p>Show bulk sizes</p>
          </a>
        {/if}
      </div>
    </div>
  </section>

  <section id="option3" class="subscriptions-section">
    <div class="subscriptions-section-vwrap">
      <Heading
        text="5. Which Payment Plan?"
        img="https://coavacoffee.com/uploads/subscriptions/subscription_payment_03.jpg" />

      <div class="grid grid--3 grid--align_top">
        {#if recurring}
          <PropertyOption
            group="paymentFrequency"
            value={'Pay Per Shipment'}
            displayValue="Pay Per Shipment"
            description=""
            img="https://coavacoffee.com/uploads/subscriptions/subscription_payment_01.jpg" />
        {:else}
          <PropertyOption
            group="paymentFrequency"
            value={[3, 'Months']}
            displayValue="3 Months"
            description="(12 weeks if shipped bi-weekly)"
            img="https://coavacoffee.com/uploads/subscriptions/subscription_payment_02.jpg" />
        {/if}
        <PropertyOption
          group="paymentFrequency"
          value={[6, 'Months']}
          displayValue="6 Months"
          description="(24 weeks if shipped bi-weekly)"
          discountText="Save 5%"
          img="https://coavacoffee.com/uploads/subscriptions/subscription_payment_02.jpg" />
        <PropertyOption
          group="paymentFrequency"
          value={[12, 'Months']}
          displayValue="12 Months"
          description="(48 weeks if shipped bi-weekly)"
          discountText="Save 10%"
          img="https://coavacoffee.com/uploads/subscriptions/subscription_payment_03.jpg" />
      </div>
    </div>
  </section>

  <div class="subscriptions-summary">
    <div class="text_card text_card--outline text_card--centered">
      <div class="text_card-title_decorator">
        <h2 class="text_card-title">Summary</h2>
      </div>
      <div class="text_card-content">
        <div class="subscriptions-summary-properties">
          <SummaryItem
            anchor="flavor"
            label="Flavor Profile"
            value={$flavorDisplayValue} />
          <SummaryItem
            anchor="roast"
            label="Roast"
            value={$roastDisplayValue} />
          <SummaryItem
            anchor="option2"
            label="Frequency"
            value={$shippingFrequencyDisplayValue} />
          <SummaryItem
            anchor="option1"
            label="Size"
            value={$sizeDisplayValue} />
          <SummaryItem
            anchor="option3"
            label={recurring ? 'Payment Plan' : 'Duration'}
            value={$paymentFrequencyDisplayValue} />
          <div class="subscriptions-summary-properties-item">
            <h3>Shipping</h3>
            <p>
              <strong>Free!</strong>
            </p>
          </div>
          <br>
          <div class="subscriptions-summary-properties-item">
            <label class="form-label">
              <div class="form-label-text">Grind Preference</div>
              <div class="form-select">
                <select class="form-select-input" name="properties[Grind]">
                  <option value="" selected>Whole Bean (Default)</option>
                  <option value="Drip (Medium)">Grind – Drip (Medium)</option>
                  <option value="Espresso (Fine)">Grind – Espresso (Fine)</option>
                  <option value="French Press (Course)">Grind – French Press (Course)</option>
                  <option value="Pour Over (Medium Fine)">Grind – Pour Over (Medium Fine)</option>
                </select>
                <div class="form-select-arrow"></div>
              </div>
            </label>
          </div>
          <div class="subscriptions-summary-properties-item">
            <label class="form-label">
              <div class="form-label-text">Special Requests</div>
              <textarea class="form-textarea" name="properties[Requests]" rows="2" placeholder="Have a special request? Let us know!"></textarea>
            </label>
          </div>
        </div>
        {#if chosenVariantId}
          <div class="subscriptions-summary-total">
            <h4>Total</h4>
            {#if $paymentFrequencyDisplayValue === 'Pay Per Shipment'}
              <h5>{price} per shipment</h5>
              <p />
            {:else}
              <h5>
                {#if comparePerShipmentPrice}
                  <strike>{comparePerShipmentPrice}</strike>
                {/if}
                {perShipmentPrice} Per Shipment
              </h5>
              {#if recurring}
                <p>
                  Pay <strong>{price}</strong> every
                  <strong>
                    {$standardizedPaymentFrequency[0]}
                    {$standardizedPaymentFrequency[1]}
                  </strong>
                  ({shipmentCount} shipments)
                </p>
              {:else}
                <p>
                  Pay <strong>{price}</strong> over
                  <strong>
                    {$standardizedPaymentFrequency[0]}
                    {$standardizedPaymentFrequency[1]}
                  </strong>
                  ({shipmentCount} shipments)
                </p>
              {/if}
            {/if}
          </div>
        {/if}

        <button
            type="submit"
            class="button js-add-subscription"
            disabled="{!chosenVariantId}">
          Add to Cart
        </button>

        <HiddenField {debug} name="id" value="{chosenVariantId}" />
        <HiddenField {debug} name="quantity" value="1" />

        <HiddenField
            {debug}
            name="selling_plan"
            value={chosenSellingPlanId} />
        <HiddenField
            {debug}
            name="properties[Profile]"
            value={$flavor} />
        <HiddenField
            {debug}
            name="properties[Roast]"
            value={$roast} />
        {#if debug}
          <br />
          <br />
          <br />
        {/if}
      </div>
    </div>
  </div>
</div>
